export const BASE_ADMIN_PATH = '/admin';
export const BASE_ADMIN_V2_PATH = '/admin-v2';
